/**
 * An anonymous id for one kiosk visit (one person's go at checking in). Held in memory by the page only -- no
 * cookie, no storage -- and replaced when the page is reset for the next person. The server uses it solely to tell
 * whether a visit whose member lookup failed went on to check in (self_checkin_lookup_log, migration 1041).
 */
export function newAttemptId(): string {
  try {
    if (
      typeof crypto !== "undefined" &&
      typeof crypto.randomUUID === "function"
    ) {
      return crypto.randomUUID();
    }
  } catch {
    /* fall through */
  }
  // RFC 4122 v4 shape from Math.random (only reached on very old browsers; uniqueness, not secrecy, is needed)
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (ch) => {
    const r = (Math.random() * 16) | 0;
    return (ch === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}
